import {ISupportTicketRequest} from 'types/diplomat/SupportTicketRequest';
import {call, put} from 'redux-saga/effects';
import ApiService from 'api/ApiService';
import {getFileName} from 'api/helpers';
import api from 'api';
import {LOG_ROWS_TO_SEND} from 'common/constants';
import {downloadFile} from 'common/downloadFile';
import {DialogTypes} from 'common/names';
import {layoutActions, layoutTypes} from 'features/layout/redux';
import i18n from 'i18n';
import {getErrors} from 'redux/common';
import {action} from 'redux/helpers';
import {pushErrorToast, pushSuccessToast} from 'features/notifications/redux/actions';
import safeStringify from 'safe-stringify';

function* downloadSaga(url: string, body: string) {
   //    try {
   const res = (yield call(ApiService.postSecureJson, url, body)) as Response;
   const blob = (yield call(res.blob.bind(res))) as Blob;
   //   setState(blob);
   //   options?.onSuccess?.();
   //   setLoading(false);
   const fileName = getFileName(res);
   if (res.status === 204) {
      yield put(
         layoutActions.openSubDialog({
            id: DialogTypes.AlertDialog.id,
            title: res.statusText,
            content: i18n.t('No records found.'),
         })
      );
   } else {
      yield call(downloadFile, blob, fileName!);
   }
   //    } catch (e) {
   //       const {message, error} = yield call(getErrors, e, url);
   //       //   handleError()(e as Response);
   //       //   options?.onFailure?.(e, (e as Error).message);
   //    }
}

const EXCLUDE_REDUX_TYPES = [
   layoutTypes.GET_STATES.REQUEST,
   layoutTypes.GET_STATES.SUCCESS,
   layoutTypes.UPDATE_STATES_FULL.REQUEST,
   layoutTypes.UPDATE_STATES_FULL.SUCCESS,
];
export function* sendSupportTicketSaga(act: {type: string; payload: ISupportTicketRequest}) {
   try {
      yield put(action(layoutTypes.SEND_SUPPORT_TICKET.REQUEST, act.payload));

      const logs = console.logs.reduceRight((res, current) => {
         if (
            res.length < LOG_ROWS_TO_SEND &&
            (!current[2]?.type || EXCLUDE_REDUX_TYPES.indexOf(current[2]?.type) < 0)
         ) {
            res.push(current);
         }
         return res;
      }, []);
      console.debug('logs', logs);
      const logString = safeStringify(logs);
      // console.debug('SupportTicketDialog submit: ', logs, logString.length);
      const data = {...act.payload, logs: logString};
      // console.debug('SupportTicketDialog submit: ', data);
      yield call(downloadSaga, api.supportTicketRequest, JSON.stringify(data));
      yield put(action(layoutTypes.SEND_SUPPORT_TICKET.SUCCESS, act.payload));
      yield put(
         pushSuccessToast(
            i18n.t(
               `Support Details Generated.
File has been downloaded by your browser.
Feel free to review the contents of the Zip file, and when you are ready please email it to support@coviantsoftware.com.
This will generate a support ticket and our team will respond as quickly as possible.`
            )
         )
      );
   } catch (e) {
      console.error(e);
      const {message, error} = yield call(getErrors, e, api.supportTicketRequest);
      yield put(action(layoutTypes.SEND_SUPPORT_TICKET.ERROR, error));
      yield put(pushErrorToast(message));
   }
}
